module.exports = function getResource (label, vars = []) {
    const resources = {
        checkout: 'Passer à la caisse'
    };

    return resources[label];
};
